import { useEffect } from 'react';
import { Typography } from '../../../../../../core/components/molecules/Typography';
import { IEssayTheme } from '../../../../../../core/models/essay';
import { useCreatePracticeEssay } from '../../../../hooks/createPracticeEssay';
import { useGetUserPracticeEssay } from '../../../../hooks/getPracticeEssay';
import { practiceEssayStore } from '../../../../stores/practiceEssayStore';
import { toast } from '../../../../../../core/components/atoms/Toast';
import InnerHTMLContainer from '../../../../../../core/components/molecules/InnerHTMLContainer';
import WriteEssay from '../../../../../Essay/pages/Writing';
import { Alert } from '../../../../../../core/components/atoms/Alert';

interface IPracticeEssayTheme {
  theme: Partial<IEssayTheme>;
  setIsTextSent: (isTextSent: boolean) => void;
}

const PracticeEssayTheme: React.FC<IPracticeEssayTheme> = ({ theme, setIsTextSent }) => {
  const { mutate, isPending, isError, error } = useCreatePracticeEssay();
  const { setEssay } = practiceEssayStore()
  
  const { isError: essayError, data  } = useGetUserPracticeEssay(theme.slug || "", setEssay)

  useEffect(() => {
    if(theme._id && !data?._id) {
      mutate({ theme: theme._id, moduleOrigin: 'exam' })
    }
  }, [theme])

  useEffect(() => {
    if(isError) {
      toast({ 
        variant: 'error', 
        message: error?.message || 'Não foi possivel iniciar a redação', 
        title: 'Erro!' 
      })
    }
  }, [isError])

  useEffect(() => {
    if(essayError) {
      toast({ 
        variant: 'error', 
        message: 'Não foi possivel recuperar a redação', 
        title: 'Erro!' 
      })
    }
  }, [essayError])

  useEffect(() => {
    if(data?.sentCorrection) {
      setIsTextSent(true);
    }
  }, [data])

  const removeAlign = (html?: string) => {
    if (html) {
      html = html.replace(
        /<p[^>]*style\s*=\s*['"]?[^'"]*text-align\s*:\s*left[^'"]*['"]?[^>]*>/gi,
        '<p>'
      );
      html = html.replace(
        /<p[^>]*style\s*=\s*['"]?[^'"]*text-align\s*:\s*right[^'"]*['"]?[^>]*>/gi,
        '<p>'
      );

      return html;
    }

    return '';
  };

  if(isPending) {
    return (
      <p>
        Carregando tema...
      </p>
    )
  }

  return (
    <div className="bg-white p-5 rounded-md" id={data?._id || ""}>
      <div className="md:w-3/4 xs:w-full m-auto">
        <Typography type="title" size="h5" className="text-mono-color-darkest text-center mb-8">
          {theme.motivationalTitle}
        </Typography>
        <InnerHTMLContainer
          type='essay'
          align='center'
          font='noto'
          data={removeAlign(theme.motivationalText) || ''}
          className="[&]:text-center mb-12 text-mono-color-darkest"
        />
        <Typography type="title" size="h5" className="text-mono-color-darkest mb-2 text-center">
          Proposta de Redação
        </Typography>
        <Typography className="text-mono-color-darkest text-center">
          A partir da leitura dos textos motivadores e com base nos conhecimentos construídos ao longo de sua formação, 
          redija texto dissertativo-argumentativo em modalidade escrita formal da língua portuguesa sobre o tema 
          <strong>“{theme.motivationalTitle}”</strong>, apresentando proposta de intervenção, que respeite os 
          direitos humanos. Selecione, organize e relacione, de forma coerente e coesa, argumentos e fatos para defesa de 
          seu ponto de vista.
        </Typography>
      </div>
      {data?.sentCorrection && (
        <Alert
          variant='warning'
          title='Sua redação foi enviada via área de redações'
          className='mt-10'
        />
      )}
      <WriteEssay key={theme.slug} origin="practice" slug={theme.slug}/>
    </div>
  )
}

export default PracticeEssayTheme;